import { render } from "./EinstellungenView.vue?vue&type=template&id=9accdae8&scoped=true"
import script from "./EinstellungenView.vue?vue&type=script&lang=js"
export * from "./EinstellungenView.vue?vue&type=script&lang=js"

import "./EinstellungenView.vue?vue&type=style&index=0&id=9accdae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9accdae8"]])

export default __exports__